import React, { Fragment } from 'react';
import './_index.scss';
import LazyImage from '../LazyImage';

const Footer = () => (
  <Fragment>
    <section className="Section Section-socials">
      <div className="container">
        <div className="Section-socials__apps">
          <a className="Section-socials__apps__item" href="https://go.onelink.me/L1z6/icon" rel="nofollow" aria-label="App Store"><LazyImage src="/images/ico_app-store.svg" alt="" /></a>
        </div>
        <div className="Section-socials__links">
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a className="Section-socials__links__item" href="//www.instagram.com/customwritings_official/" target="_blank" rel="nofollow noopener"><LazyImage src="/images/ico_instagram.svg" alt="" /></a>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a className="Section-socials__links__item" href="//www.facebook.com/customwritingscom/" rel="nofollow noopener" target="_blank"><LazyImage src="/images/ico_facebook.svg" alt="" /></a>
        </div>
      </div>
    </section>
    <footer className="Section main-footer">
      <div className="container">
        <div className="main-footer__row main-footer__row--column-4">
          <div className="main-footer__cell">
            <div className="main-footer__label">Company</div>
            <ul>
              <li><a href="https://www.customwritings.com/about-us.html" rel="nofollow">About Us</a></li>
              <li><a href="https://www.customwritings.com/contact-us.html" rel="nofollow">Contact Us</a></li>
              <li><a href="https://www.customwritings.com/our-services.html" rel="nofollow">Our Services</a></li>
              <li><a href="https://www.customwritings.com/progressive-delivery.html" rel="nofollow">Progressive Delivery</a></li>
              <li><a href="https://www.customwritings.com/discount.html" rel="nofollow">Discount</a></li>
              <li><a href="https://www.customwritings.com/become-a-writer.html" rel="nofollow">Become a writer</a></li>
            </ul>
          </div>
          <div className="main-footer__cell">
            <div className="main-footer__label">Resources</div>
            <ul>
              <li><a href="https://www.customwritings.com/our-essay-samples.html" rel="nofollow">Our Essay Samples</a></li>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <li><a href="https://howtowrite.customwritings.com/free-essay-tools/" target="_blank">Free Essay Writing Tools</a></li>
              <li><a href="https://www.customwritings.com/essay-writing-app.html" rel="nofollow">Essay Writing App</a></li>
              <li><a href="https://www.customwritings.com/blog/">Blog</a></li>
              <li><a href="https://www.customwritings.com/frequently-asked-questions.html" rel="nofollow">FAQ</a></li>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <li><a href="https://howtowrite.customwritings.com/" target="_blank" rel="nofollow">Writing Guide</a>
              </li>
            </ul>
          </div>
          <div className="main-footer__cell">
            <div className="main-footer__label">Terms</div>
            <ul>
              <li><a href="https://www.customwritings.com/terms-conditions.html" rel="nofollow">Terms and Conditions</a></li>
              <li><a href="https://www.customwritings.com/cookie-policy.html" rel="nofollow">Cookie Policy</a></li>
              <li><a href="https://www.customwritings.com/privacy-policy.html" rel="nofollow">Privacy Policy</a></li>
              <li><a href="https://www.customwritings.com/social-responsibility-notice.html" rel="nofollow">Notice on Social Responsibility</a></li>
            </ul>
          </div>
          <div className="main-footer__cell">
            <div className="main-footer__langs">
              <div className="main-footer__label">Language</div>
              <div className="main-footer__langs__list">
                <a href="https://cn.customwritings.com/">
                  <LazyImage
                    src="/images/ico_lang-cn.svg"
                    alt="Cn.CustomWritings.com - 论文代写服务"
                    title="Cn.CustomWritings.com - 论文代写服务"
                    width="35"
                    height="24"
                  />
                </a>
                <a href="https://ar.customwritings.com/">
                  <picture>
                    <source srcSet="/images/ico_lang-ar.webp" type="image/webp" />
                    <img src="/images/ico_lang-ar.png" alt="Ar.CustomWritings.com - خدمة كتابة المقال باحترافية لاستخدام الخبير الموثوق المحترف" title="Ar.CustomWritings.com - خدمة كتابة المقال باحترافية لاستخدام الخبير الموثوق المحترف" width="35" height="24" />
                  </picture>
                </a>
                <a href="https://ca.customwritings.com/">
                  <LazyImage
                    src="/images/ico_lang-ca.svg"
                    alt="Custom Essay Writing Service That You Can Rely On - Ca.CustomWritings.com"
                    title="Custom Essay Writing Service That You Can Rely On - Ca.CustomWritings.com"
                    width="35"
                    height="24"
                  />
                </a>
                <a href="https://www.customwritings.com/">
                  <LazyImage
                    src="/images/ico_lang-world.svg"
                    alt="CustomWritings.com"
                    title="CustomWritings.com"
                    width="36"
                    height="24"
                  />
                </a>
              </div>
            </div>
            <div className="main-footer__accept">
              <div className="main-footer__label">We accept</div>
              <LazyImage src="/images/ico_payments.svg" alt="" />
            </div>
          </div>
        </div>

        <div className="main-footer__row">
          <div className="main-footer__label">Services</div>
          <ul className="main-footer__row main-footer__row--column-4 main-footer__row--services">
            <li><a href="/dissertation-writing-service.html">Dissertation Writing Service</a></li>
            <li><a href="/dissertation-proposal.html">Dissertation Proposal Writing</a></li>
            <li><a href="/assignment-writing-service.html">Assignment Writing Service</a></li>
            <li><a href="/buy-assignment.html">Buy Assignment</a></li>
            <li><a href="/pay-for-assignment.html">Pay For Assignment</a></li>
            <li><a href="/speech-writing-services.html">Speeches</a></li>
            <li><a href="/pay-for-essay.html">Pay For Essay</a></li>
            <li><a href="/college-essays.html">College Essays</a></li>
            <li><a href="/law-essays.html">Law Essays</a></li>
            <li><a href="/mba-essays.html">MBA Essays</a></li>
            <li><a href="/coursework-writing-service.html">Coursework Writing Service</a></li>
            <li><a href="/buy-coursework.html">Buy Coursework</a></li>
            <li><a href="/do-my-coursework.html">Do My Coursework</a></li>
            <li><a href="/gcse-coursework.html">GCSE Coursework Writing</a></li>
            <li><a href="/write-my-dissertation.html">Write My Dissertation</a></li>
            <li><a href="/buy-dissertation.html">Buy Dissertation</a></li>
            <li><a href="/pay-for-dissertation.html">Pay For Dissertation</a></li>
            <li><a href="/personal-statement-writing-service.html">Personal Statement</a></li>
            <li><a href="/buy-book-reviews.html">Book Reviews</a></li>
            <li><a href="/lab-report-writing-service.html">Lab Reports</a></li>
            <li><a href="/literature-review-writing-service.html">Literature Reviews</a></li>
            <li><a href="/research-paper-writing-service.html">Research Papers</a></li>
            <li><a href="/buy-research-papers.html">Buy Research Papers</a></li>
          </ul>
        </div>
        <div className="main-footer__row main-footer__row--column-2">
          <div className="main-footer__cell main-footer__cell--attention">
            <div className="main-footer__label">Attention!</div>
            <p>Using this writing service is legal and is not prohibited by any university/college policies.</p>
            <p>Read more about how you can use a custom written paper you get from us.</p>
          </div>
        </div>
        <div className="main-footer__copyright">
          <p>&copy; 2008 — {new Date().getFullYear()} Writera Limited. All Rights Reserved.</p>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a className="main-footer__dmca" href="https://www.dmca.com/Protection/Status.aspx?ID=35fde21e-6aab-49cc-bed4-2d85382a0b27" target="_blank" rel="nofollow noopener">
            <img
              src="//images.dmca.com/Badges/dmca_protected_sml_120l.png?ID=35fde21e-6aab-49cc-bed4-2d85382a0b27"
              alt="DMCA.com"
            />
          </a>
        </div>
      </div>
    </footer>
  </Fragment>
);

export default Footer;
